import { Chain } from '@shared/data-access/interfaces';
import { GamData } from './google-ad-manager.interface';
import { Component, Input, OnInit, Inject, HostListener, input } from '@angular/core';

import { AnalyticsService, WINDOW } from '@shared/utils/services';
import { CommonModule } from '@angular/common';
import { homefieldIconAlertInfoFilled, HomefieldIconLibraryModule, HomefieldIconsLibraryService } from '@dsg-tech/homefield-angular-icons';

@Component({
    selector: 'shared-components-google-ad-manager',
    templateUrl: './google-ad-manager.component.html',
    styleUrls: ['./google-ad-manager.component.scss'],
    imports: [CommonModule, HomefieldIconLibraryModule],
	standalone: true
})

export class GoogleAdManagerComponent implements OnInit {
	@Input() data: string;
	@Input() breadcrumbData = null;
	@Input() showSponsoredLabel = false;
	@Input() addlData: any;
	enableTooltipSurvey = input(true);

	gamData: GamData | undefined;
	isDsgStorePage: boolean;

	constructor(
		private readonly analyticsService: AnalyticsService,
		@Inject(WINDOW) protected window: Window,
		private readonly chain: Chain,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([homefieldIconAlertInfoFilled]);
	}

	ngOnInit(): void {
		this.showSponsoredLabel = this.addlData?.data[0]?.showSponsoredLabel ?? this.showSponsoredLabel;
		const analyticsEventObject = {AdSpotIDs: this.data};
		// add breadcrumbs data to analytics event if category page has breadcrumbs
		if (this.breadcrumbData) {
			analyticsEventObject['Breadcrumbs'] = this.breadcrumbData;
		}

		this.analyticsService.triggerAnalyticsEvent('AdSpotsReady', analyticsEventObject);
		this.isDsgStorePage = this.window.location.href.endsWith('/s/stores') && this.chain.chainIdentifierAbbr === 'dsg';
	}

	loadSurvey(): void {
		if (typeof this.window.KAMPYLE_ONSITE_SDK !== 'undefined' && this.enableTooltipSurvey()) {
				this.window.gamData = this.gamData;
				if (this.chain.chainIdentifierAbbr === 'dsg') {
					this.window.KAMPYLE_ONSITE_SDK.showForm(15821);
				}
				else if (this.chain.chainIdentifierAbbr === 'gg') {
					this.window.KAMPYLE_ONSITE_SDK.showForm(16385);
				}
		}
	}

	@HostListener('window:message', ['$event'])
	onMessage(event: MessageEvent): void {
		if (!this.enableTooltipSurvey()) {
			return;
		}
		const allowedHosts = ['safeframe.googlesyndication.com'];
		let originHost: string;
		try {
			originHost = new URL(event.origin).hostname;
		} catch (e) {
			return;
		}

		if (originHost.endsWith(allowedHosts[0])) {
			const adData = event.data;
			let parsedAdData;
			// Google pumps out a lot of events with this hostname, sometimes the data is not json
			try {
				parsedAdData = JSON.parse(adData);
			} catch (e) {
				return;
			}

			if (parsedAdData?.Header && !this.gamData) { 
				this.gamData = parsedAdData;
			}
		}
	}
}